<div class="content-heading">
  <div class="header-container">
    <h3>Vehículos de Logística Secundaria</h3>
    <small>Catálogo y gestión de unidades por centro de venta</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default">
    <div class="card-body">

      <div class="row mb-4 align-items-end">
        <div class="col-md-5">
          <label class="text-bold">Centro de Venta (CEVE)</label>
          <div class="ng-autocomplete">
            <ng-autocomplete placeholder="Buscar centro de venta..." [data]="ceveList" [searchKeyword]="keyword"
              (selected)='selectEvent($event)' (inputCleared)="cmbOutputCeve()" [itemTemplate]="itemTemplate"
              [notFoundTemplate]="notFoundTemplate" [(ngModel)]="selectedUnit">
            </ng-autocomplete>

            <ng-template #itemTemplate let-item>
              <a [innerHTML]="item.CeveName"></a>
            </ng-template>

            <ng-template #notFoundTemplate let-notFound>
              <div [innerHTML]="'No se encontraron coincidencias'"></div>
            </ng-template>
          </div>
        </div>
        <div class="ml-auto mr-3 align-self-end">
          <aph-custom-buttons type="button" preset="refresh" (btnClick)="refresh()"></aph-custom-buttons>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-ceq-table #CeqGrid [gridAdditionalOptions]="gridOptions" [columnDef]="columnDefs"
            (apiEmitter)="gridEmiter($event)">
          </app-ceq-table>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 ">
          <aph-custom-buttons preset="add" label="Nuevo vehículo" (btnClick)="btnAddClick()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>